
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CatalogPage from '../pages/catalog/page';
import MasculinoPage from '../pages/masculino/page';
import FemininoPage from '../pages/feminino/page';
import AccessoriesPage from '../pages/accessories/page';
import BagsPage from '../pages/bags/page';
import WatchesPage from '../pages/watches/page';
import ItalianPage from '../pages/italian/page';
import Line11Page from '../pages/line11/page';
import Line12Page from '../pages/line12/page';
import OutletPage from '../pages/outlet/page';
import ProdutosPage from '../pages/produtos/page';
import ApresentacaoPage from '../pages/apresentacao/page';
import EquipePage from '../pages/equipe/page';
import ContatosPage from '../pages/contatos/page';
import CartPage from '../pages/cart/page';
import CheckoutPage from '../pages/checkout/page';
import OrderConfirmedPage from '../pages/order-confirmed/page';
import AgendamentoPage from '../pages/agendamento/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/catalogo',
    element: <CatalogPage />
  },
  {
    path: '/masculino',
    element: <MasculinoPage />
  },
  {
    path: '/feminino',
    element: <FemininoPage />
  },
  {
    path: '/acessorios',
    element: <AccessoriesPage />
  },
  {
    path: '/bolsas',
    element: <BagsPage />
  },
  {
    path: '/relogios',
    element: <WatchesPage />
  },
  {
    path: '/italiano',
    element: <ItalianPage />
  },
  {
    path: '/linha-11',
    element: <Line11Page />
  },
  {
    path: '/linha-12',
    element: <Line12Page />
  },
  {
    path: '/outlet',
    element: <OutletPage />
  },
  {
    path: '/produtos',
    element: <ProdutosPage />
  },
  {
    path: '/apresentacao',
    element: <ApresentacaoPage />
  },
  {
    path: '/equipe',
    element: <EquipePage />
  },
  {
    path: '/contatos',
    element: <ContatosPage />
  },
  {
    path: '/carrinho',
    element: <CartPage />
  },
  {
    path: '/checkout',
    element: <CheckoutPage />
  },
  {
    path: '/pedido-confirmado',
    element: <OrderConfirmedPage />
  },
  {
    path: '/agendamento',
    element: <AgendamentoPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
